import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'

import {RoundedPaidIcon, ReceiptLongIcon} from '~/react/icons'

const PlaceHolder = () => {
  return (
    <Box
      display="flex"
      borderColor="mld.neutral.200"
      borderWidth="1px"
      borderRadius="4px"
      width="300px"
      padding="sm"
      alignItems="center"
      justifyContent="space-around"
      boxShadow="0px 0px 8px #8A878450"
      margin="xs"
    >
      <Box>
        <ReceiptLongIcon color="mld.neutral.700" />
      </Box>
      <Box
        backgroundColor="mld.neutral.200"
        width="185px"
        height="16px"
        borderRadius="2px"
        margin="xs"
      />
      <Box>
        <RoundedPaidIcon color="mld.neutral.600" />
      </Box>
    </Box>
  )
}

const EmptyState = ({heading, subHeading}) => {
  return (
    <Box padding="md">
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box
          height="180px"
          overflow="hidden"
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <PlaceHolder />
          <PlaceHolder />
          <PlaceHolder />
        </Box>
        <Box textAlign="center" pb="sm">
          <Text textStyle="body-intro-medium" pt="md">
            {heading}
          </Text>
          <Text textStyle="body-small" pt="sm">
            {subHeading}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

EmptyState.propTypes = {
  heading: PropTypes.string.isRequired,
  subHeading: PropTypes.string.isRequired,
}

export default EmptyState
